import React from 'react';
// import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  fitting: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (fitting, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      fitting,
    },
  });

export const Fitting = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const productType = getBaseProductType(state.context);

  const fittingTypes = baseProduct
    ? baseProduct.metafields.installation || []
    : [];

  if (!Array.isArray(fittingTypes) || fittingTypes.length === 0) {
    if (isCurrentState('fitting', state)) {
      throwError(state);
    }
  }
  const blindType =
    typeof productType === 'string' ? productType.toLowerCase() : 'blind';

  return (
    <SectionContent>
      <Heading>Fitting</Heading>
      <Caption>How are you mounting your {blindType}s?</Caption>
      <Selector isSlider={true}>
        {fittingTypes.map(fitting => {
          const isSelected = fitting === state.context.custom.fitting;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'fitting',
            fitting,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(fitting, send)}
              showIcon={showIcon}
              key={fitting}
              Icon={Icon}
              title={fitting}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
